import { routePaths } from "@/shared/config/routePaths";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DroolsEditorPage = lazy(() => import('./DroolsEditorPage').then(m => ({ default: m.DroolsEditorPage })));

export const droolsEditorRouter: RouteObject = {
    path: routePaths.droolsEditor,
    element: <DroolsEditorPage />
}
